// Firebase configuration
// Using environment variables for better security and flexibility
// Values are loaded from frontend/.env file

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, Analytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAk1IDTaSq7Qc2_9oIyPDYWo9WgO6yJM1c",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "zebed-service.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "zebed-service",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "zebed-service.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "608889631765",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:608889631765:web:25d6371279aff1a7f74a1c",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-YZSHF9M4PM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Analytics (optional - only in production)
let analytics: Analytics | null = null;
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production') {
  analytics = getAnalytics(app);
}

export { analytics };
export default app;


